import { Directive, ElementRef, Renderer2, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { DragDropManagerService } from 'sharedFeatures/sharedServices/drag-drop-manager.service';
import { ListDropEvent } from './events/list-drop-event';
import { XeroMatchedAccount } from "sharedFeatures/sharedModels/xero/xeroMatchedAccount";
import { DragData } from "sharedFeatures/sharedModels/xero/dragData";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';

@Directive({
    selector: '[list-drop-target]',
    standalone: true
})
export class ListDropTargetDirective implements OnInit {


    @Output() private drop: EventEmitter<any> = new EventEmitter();

    @Input()
    public isDropAllowed: Function = this.dropAllowedDefault;

    @Input()
    public getPosition: Function = this.getPositionDefault;

    @Input()
    public onDragOver: Function = this.onDragOverDefault;

    @Input()
    public onDragEnter: Function = this.onDragEnterDefault;

    @Input()
    public onDragLeave: Function = this.onDragLeaveDefault;

    @Input()
    public onItemDragOver: Function = this.onItemDragOverDefault;

    @Input()
    public onItemDragEnter: Function = this.onItemDragEnterDefault;

    @Input()
    public onItemDragLeave: Function = this.onItemDragLeaveDefault;


    @Input()
    public onDrop: Function = this.onDropDefault;

    @Input()
    private dropTargetObject: any;

    private targetItem: HTMLElement | undefined;

    private dragLine: HTMLElement | undefined;

    private curChildrenCount: number = 0;
    private listeners: Array<any> = [];

    private moveListenerMap: Map<Element, Function> = new Map<Element, Function>();
    private leaveListenerMap: Map<Element, Function> = new Map<Element, Function>();

    private scrollInterval: any;

    constructor(private el: ElementRef,
        private r: Renderer2,
        private ddService: DragDropManagerService
    ) {

        this.ddService.addDropTarget(this);

    }

    ngOnInit(): void {

        let dom = this.el.nativeElement;

    }



    private setListeners(): void {

        //unlisten
        this.listeners.forEach((listener) => {

            listener();

        });

        this.moveListenerMap.forEach((listener, key) => {

            listener();
            this.moveListenerMap.delete(key);

        });

        this.leaveListenerMap.forEach((listener, key) => {

            listener();
            this.leaveListenerMap.delete(key);

        });

        this.listeners = [];


        Array.from(this.getEl().children).forEach((el: Element) => {

            const item = <HTMLElement>el;

            if (DomSmallUtils.hasClass(item, 'dd-drag-proxy')) return;

            this.listeners.push(this.r.listen(item, 'mouseenter', (ev) => {

                this.targetItem = item;
                if (!this.ddService.isDragActive()) return;
                let data = this.ddService.getActiveDraggable()?.getDragData();
                this.onItemDragEnter(ev, item, this, data);




                this.moveListenerMap.set(item, this.r.listen(item, 'mousemove', (ev) => {

                    this.targetItem = item;
                    if (!this.ddService.isDragActive()) return;
                    let data = this.ddService.getActiveDraggable()?.getDragData();
                    this.onItemDragOver(ev, item, this, data);

                    this.onDragOver(ev, this, data);

                }));
                this.leaveListenerMap.set(item, this.r.listen(item, 'mouseleave', (ev) => {

                    if (!this.ddService.isDragActive()) return;
                    let data = this.ddService.getActiveDraggable()?.getDragData();
                    this.onItemDragLeave(ev, item, this, data);

                    let func = this.moveListenerMap.get(item);
                    if (func) {
                        func();
                        this.moveListenerMap.delete(item);
                    }

                    let func2 = this.leaveListenerMap.get(item);

                    if (func2) {
                        func2();
                        this.leaveListenerMap.delete(item);
                    }

                }));


            }));


        });

    }

    ngAfterViewChecked() {

        let count = 0;

        Array.from(this.getEl().children).forEach((el: Element) => {
            const item = <HTMLElement>el;
            if (DomSmallUtils.hasClass(item, 'dd-drag-proxy')) return;
            count++;
        })

        // If list items quantity was changed or items were reloaded, set events on the new items
        if (this.curChildrenCount !== count || jQuery(this.getEl()).data('wasReloaded') ||
            (this.dropTargetObject && this.dropTargetObject.wasReloaded)) {

            this.setListeners();

            jQuery(this.getEl()).removeData('wasReloaded');

            if (this.dropTargetObject) {
                this.dropTargetObject.wasReloaded = false;
            }

        }

        this.curChildrenCount = count;

    }


    onDragOverDefault(ev: MouseEvent): void {

        if (!this.ddService.isDragActive()) return;
        if (this.targetItem === undefined) return;

        if (this.dragLine === undefined) {
            this.dragLine = DomSmallUtils.generateElements('<div class="dd-dragline f1Background"></div>');
            this.r.appendChild(<HTMLElement>ev.target, this.dragLine);
        }

        let d = this.ddService.getActiveDraggable();

        if (!d) return;

        const dragData = d.getDragData();

        let position = this.getPosition(ev, dragData, this.targetItem);

        if (!this.isDropAllowed(dragData, this.targetItem, position)) return;

        // Background when dragging group into other sections
        if (position == 'append' && !dragData.isComponent) {
            this.r.setStyle(this.dragLine, 'display', 'none');
            document.querySelectorAll('.f2Background-drop-target').forEach((el: Element) => {
                this.r.removeClass(el, 'f2Background-drop-target');
            });
            this.r.addClass(this.targetItem, 'f2Background-drop-target')
            return;
        }

        this.r.setStyle(this.dragLine, 'display', '');

        let targetOffset = DomSmallUtils.offset(this.targetItem);

        this.r.setStyle(this.dragLine, 'width', DomSmallUtils.outerWidth(this.targetItem) + 'px');
        if (position == 'before') DomSmallUtils.setOffset(this.dragLine, targetOffset);
        else DomSmallUtils.setOffset(this.dragLine, { top: targetOffset.top + DomSmallUtils.height(this.targetItem), left: targetOffset.left });

    }



    @HostListener('mouseenter', ['$event'])
    onMouseEnter(ev: Event): void {

        if (!this.ddService.isDragActive()) return;

        let d = this.ddService.getActiveDraggable();

        if (!d) return;

        this.onDragEnter(ev, this, d.getDragData());

    }

    onDragEnterDefault(ev: Event): void {
        return;
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(ev: Event): void {

        if (this.dragLine !== undefined) {
            this.dragLine.remove();
            this.dragLine = undefined;
        }

        if (!this.ddService.isDragActive()) return;

        let d = this.ddService.getActiveDraggable();

        if (!d) return;

        this.onDragLeave(ev, this, d.getDragData());

        if (this.scrollInterval) clearInterval(this.scrollInterval);

    }

    onDragLeaveDefault(ev: Event): void {

        document.querySelectorAll('.f2Background-drop-target').forEach((el: Element) => {
            this.r.removeClass(el, 'f2Background-drop-target');
        });

    }

    @HostListener('mouseup', ['$event'])
    onMouseUp(ev:Event): void {

        if (!this.ddService.isDragActive()) return;

        let d = this.ddService.getActiveDraggable();

        if (!d) return;

        this.onDrop(ev, this, d.getDragData());

        if (this.scrollInterval) clearInterval(this.scrollInterval);

    }

    onDropDefault(ev: Event): void {

        if (this.dragLine !== undefined) {
            this.dragLine.remove();
            this.dragLine = undefined;
        }

        document.querySelectorAll('.f2Background-drop-target').forEach((el: Element) => {
            this.r.removeClass(el, 'f2Background-drop-target');
        });

        if (!this.ddService.isDragActive()) return;

        let d = this.ddService.getActiveDraggable();

        if (!d) return;
        if (this.targetItem === undefined) return;

        let pos = this.getPosition(ev, d.getDragData(), this.targetItem);

        if (!this.isDropAllowed(d.getDragData(), this.targetItem, pos)) return;


        this.drop.emit(new ListDropEvent(ev, d.getDragData(), this.targetItem, pos));

    }


    onItemDragEnterDefault(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {


    }

    onItemDragLeaveDefault(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {

    }

    onItemDragOverDefault(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {





    }

    getEl(): HTMLElement {
        return this.el.nativeElement;
    }

    private dropAllowedDefault(dragData: DragData, targetEl: Element, position: string): boolean {

        return true;

    }

    private getPositionDefault(ev: MouseEvent, dragData: DragData, targetEl: Element): string {

        return 'append';

    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscHandler(evt: KeyboardEvent) {

        this.onMouseLeave(evt);

    }


}
